<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;" :style="'height:' + height + 'px'">
      <Spin v-if="loadingStatus" fix />
      <Tree ref="tree" :data="menuData" style="margin-left: 15px" show-checkbox />
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'RolePermissionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 300
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      menuData: [],
      formFields: {
        name: '',
        code: '',
        visible: 1,
        id: this.id
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return '角色权限配置'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.loadingStatus = false
      if (this.id) {
        this.loadingStatus = true
        var _that = this
        request({
          url: _that.$config.apiContextPath + '/role/' + this.id + '/permission',
          method: 'get'
        }).then(res => {
          request({
            url: _that.$config.apiContextPath + '/menu/function',
            method: 'get'
          }).then(response => {
            _that.loadingStatus = false
            _that.constructMenuData(response.data, res.data)
          }).catch(() => {
            // _that.$Notice.error({
            //   title: '服务器数据请求失败',
            //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
            // })
            _that.loadingStatus = false
          })
        }).catch(() => {
          // _that.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          _that.loadingStatus = false
        })
      }
    }
  },
  methods: {
    constructMenuData: function(data, permissions) {
      const parents = []
      const leafs = []
      if (data && data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          const { menu, functions } = data[i]
          const options = {
            menuId: menu.id,
            label: menu.label,
            icon: menu.icon,
            expand: true,
            children: [],
            render: (h, { root, node, data }) => {
              return h('span', {}, [
                h('i', { class: ['fas', data.icon], style: { marginRight: '5px', color: '#19be6b' }}),
                h('span', data.label)
              ])
            }
          }
          let leafNode = {}
          if (!menu.parentId) {
            parents.push(options)
          } else {
            leafNode = { parent: menu.parentId, options: options }
            leafs.push(leafNode)
          }

          if (functions.length > 0) {
            for (var j = 0; j < functions.length; j++) {
              const func = functions[j]
              const node = menu.parentId ? leafNode.options.children : leafs
              const options = {
                permissionName: func.name,
                menuId: func.menuId,
                label: func.label,
                checked: permissions.includes(func.name),
                children: [],
                render: (h, { root, node, data }) => {
                  return h('span', {}, [
                    h('span', data.label)
                  ])
                }
              }
              if (menu.parentId) {
                node.push(options)
              } else {
                node.push({ parent: menu.id, options: options })
              }
            }
          }
        }
      }
      if (leafs.length > 0) {
        for (const parent of parents) {
          for (const leaf of leafs) {
            if (leaf.parent === parent.menuId) {
              parent.children.push(leaf.options)
            }
          }
        }
      }
      console.log(parents)
      this.menuData = parents
    },
    getSelectedPermissions: function() {
      this.submit = true
      const permissionNames = []
      const nodes = this.$refs.tree.getCheckedNodes()
      if (nodes.length > 0) {
        for (const node of nodes) {
          if (node.permissionName) {
            permissionNames.push(node.permissionName)
          }
        }
      }
      if (permissionNames.length === 0) {
        this.$Notice.error({
          title: '数据校验错误',
          desc: '请至少选择一个菜单功能'
        })
        this.submit = false
      } else {
        request({
          url: this.$config.apiContextPath + '/role/' + this.id + '/permission',
          method: 'POST',
          data: permissionNames
        }).then(response => {
          this.loadingStatus = false
          this.submit = false
          this.$Notice.success({
            title: '数据保存成功',
            desc: '角色权限配置成功!'
          })
          this.closeModal(false)
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.submit = false
          this.loadingStatus = false
        })
      }
    },
    saveOrUpdate: function() {
      this.getSelectedPermissions()
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

